// 促销-产品详情页优惠信息
import ajax from '@/utils/ajax';

const header = '/web';
export const reqCourseCommunity = (id) => ajax(`${header}/v1/community/${id}`);

export const reqCourseCommunitySku = (productId, productSkuId) => ajax(`${header}/v1/community/detail/product
?productId=${productId}&productSkuId=${productSkuId}`);
